var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"clearfix"}),_c('div',{staticClass:"footWrap"},[_c('div',{staticClass:"copymain animated fadeInRight"},[_vm._v(" © 2023 "),_c('strong',[_vm._v("BITMASTER")]),_vm._v(" All rights reserved. ")])])])
}]

export { render, staticRenderFns }